import React from "react";
import CataloguePage from "../catalogue-page/CataloguePage";

const ElectroincsCatalogue: React.FC = () => {
  return (
    <CataloguePage
      heading="Electronics"
      description="Explore our wide range of cutting-edge electronics for your home and work needs."
      categoryFilter="electronics"
    />
  );
};

export default ElectroincsCatalogue;
